export const getQualityPercentageRange = (percent: number): string =>
	`${Math.floor(percent / 10) * 10}%`
